const accTitles = document.querySelectorAll(".accordion-Title");

accTitles.forEach((title) => {
  title.addEventListener("click", function () {
    const parent = this.parentNode;
    const content = parent.querySelector(".accordion-content");

    if (parent.classList.contains("active")) {
      parent.classList.remove("active");
      content.style.height = `0px`;
    } else {
      accTitles.forEach((t) => {
        const p = t.parentNode;
        const c = p.querySelector(".accordion-content");
        p.classList.remove("active");
        c.style.height = `0px`;
      });

      parent.classList.add("active");
      content.style.height = `${content.scrollHeight}px`;
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const accItems = document.querySelectorAll(".acc_wrap");
  const viewMoreBtn = document.querySelector(".accContentWrapper button");
  const initialVisibleCount = 6;
  let isExpanded = false;

  if (!viewMoreBtn) return;

  if (accItems.length <= initialVisibleCount) {
    // Hide the button if items are less than or equal to 6
    viewMoreBtn.style.display = "none";
    return;
  }

  // Hide items beyond the first 6
  accItems.forEach((item, index) => {
    if (index >= initialVisibleCount) {
      item.classList.add("hidden");
    }
  });

  function updateButtonText() {
    const isHungarian = document.body.classList.contains("hu-lang");
    const span = viewMoreBtn.querySelector("span");

    if (span) {
      span.textContent = isExpanded
        ? (isHungarian ? "Kevesebbet mutat" : "View Less")
        : (isHungarian ? "További megtekintése" : "View More");
    }
  }

  // Initialize button text
  updateButtonText();

  viewMoreBtn.addEventListener("click", function () {
    isExpanded = !isExpanded;

    accItems.forEach((item, index) => {
      if (index >= initialVisibleCount) {
        item.classList.toggle("hidden", !isExpanded);
      }
    });

    updateButtonText();
  });

  // Update button text when language changes
  const observer = new MutationObserver(() => {
    updateButtonText();
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
});




